<template>
  <v-footer dark color="blue-grey darken-3" class="px-12">
    <v-row align="center" justify="center">
      <v-col class="text-center" cols="12">
        <span class="subtitle-2"
          >© Copyright 2020 KOK KIAT MACHINERY PTE LTD. All Rights Reserved |
          Company Registration: 199804182R
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {}
</script>

<style></style>
